// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";

// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';
import CoinSelectDropdown from "../components/CoinSelectDropdown";
import { config } from '../config.js';


// Import Components
import Header from "../components/HeaderComponent";
import TablePagination from "../components/TablePagination";
import SelectDropdown from "../components/SelectDropdown";

// Import Images
import managingImage from '../assets/images/manage-crypto-img.svg'
import whiteLogo from "../assets/images/logo-white.svg";
import Whitelist from './addwalletPopup/addwallet.js';

// Import Icons
import plusIcon from "../assets/images/icons/plus-white-icon.svg";
import walletIcon from "../assets/images/icons/wallet-gray-icon.svg";
import bitcoinImage from "../assets/images/bitcoin-logo.svg";
import etheriumImage from "../assets/images/etherium-logo.svg";
import qrICon from "../assets/images/icons/scan-qr-icon.svg";
import linkedinICon from "../assets/images/icons/footer-linkedin-icon.svg";
import twitterICon from "../assets/images/icons/footer-twitter-icon.svg";
import fbICon from "../assets/images/icons/footer-fb-icon.svg";
import arrowDownIcon from "../assets/images/icons/arrow-angle-down-small-icon.svg";
import walletDarkIcon from "../assets/images/icons/wallet-dark-gray-icon.svg";
import btcTagIcon from "../assets/images/icons/btc-tag-icon.svg";
import usdLogo from "../assets/images/usdt-logo.png";
import euroLogo from "../assets/images/euro-logo.svg";
import crossIcon from "../assets/images/icons/cross-gray-icon.svg";



function ChooseWallet() {
    const [addWallet, setAddWallet] = useState(false);
    const [publishWalletShow, setPublishWalletShow] = useState(false);
    const [publishWalletMobileShow, setPublishWalletMobileShow] = useState(false);
    const [userWiseCurrencyResponse, setUserWiseCurrencyResponse] = useState([]);
    const [listWallet, setListWallet] = useState(false);
    const [walletListLimit, setWalletListLimit] = useState(10);
    const [WalletCount, setWalletCount] = useState(0);

    // Custom Select Coin Start
    const selectCoinOptions = userWiseCurrencyResponse.map(res => {
        if (res.type == 'F') {
            res.currencyimage = res.currencycode.toLowerCase() == 'usd' ? usdLogo : euroLogo;
        }
        return {
            label: res.currencycode,
            shortName: res.currencycode,
            icon: res.currencyimage,
            type: res.type
        };
    });
    const onSelectCoin = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Coin End
    useEffect(() => { hendelusercurrencyres(); handeladdwallet(); }, []);


    // Add Whitelist Wallet Modal Start
    const onAddWhitelistWalletClose = () => {
        setAddWallet(false);
    }
    const onAddWhitelistWalletShow = () => {
        setAddWallet(true);
    }
    // Add Whitelist Wallet Modal End



    // Assets Withdraw Modal Start
    const onPublishWalletClose = () => {
        setPublishWalletShow(false);
    }
    const onPublishWalletShow = () => {
        setPublishWalletShow(true);
    }

    // Assets Withdraw Modal End

    // Assets Withdraw Mobile Modal Start
    const onPublishWalletMobileClose = () => {
        setPublishWalletMobileShow(false);
    }
    const onPublishWalletMobileShow = () => {
        setPublishWalletMobileShow(true);
    }
    // Assets Withdraw Mobile Modal End

    let sessionvalue = sessionStorage.getItem("logedinUser");
    async function hendelusercurrencyres() {
        try {
            if (sessionvalue) {
                let usercurrencydata = await fetch(config.API_BASE_URL + '/getuserwisecurrency', { method: 'POST', body: sessionvalue });
                let res = await usercurrencydata.json();
                // console.log({ res })
                setUserWiseCurrencyResponse(res.data);
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    async function hendelremovewallate(id) {


        const body = {
            email: (JSON.parse(sessionvalue)).email,
            _id: id,
            status: "Deleted"
        };

        try {
            const response = await fetch(config.API_BASE_URL + '/updateInsertAddWallet', {
                method: "POST",
                headers: {
                    'Content-Type': 'text/plain',
                },
                body: JSON.stringify(body)
            });
            const result = await response.json();
            window.location.href = '/add-wallet';
            return result

        } catch (error) {
            console.error('Error:', error);
        }
    }

    async function handeladdwallet(nextPage) {
        try {
            if (nextPage) {
                let NextLimit = walletListLimit + 5;
                setWalletListLimit(NextLimit);
            }

            // console.log({ walletListLimit })
            if (sessionvalue) {
                let request = `{
                    "email": "${(JSON.parse(sessionvalue)).email}",
                    "query": {"status": "Active"},
                        "skip": ${0},
                        "limit": ${walletListLimit}
                
                    }`;

                let usercurrencyaddwalletdata = await fetch(config.API_BASE_URL + '/getAddWallet', { method: 'POST', body: request });
                let res = await usercurrencyaddwalletdata.json();
                // console.log({ res })
                setListWallet(res.data.addwalletdatadetails);
                setWalletCount(res.data.addwalletCount);
            }
        } catch (err) {
            console.log(err);
        }
    }


    const onAddWallet = () => {
        setAddWallet(true);
    }
    return (
        <div className='home-page'>
            <Header />
            <section className="sec-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper mh-400">
                        <div className="top-notch-wrapper">
                            <span className="top-notch"></span>
                            <a href="#" className="logo">
                                <img src={whiteLogo} alt="logo" />
                            </a>
                        </div>
                        <div className="container">
                            <div className="otc-banner-wrapper">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h3 className="f-24 w-500">Self-Custody Wallets</h3>
                                    </div>
                                    <div className="col-md-4">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sec-choose-wallet sec-no-wallet">
                <div className="container">
                    <div className="choose-wallet-main">
                        {(listWallet.length == 0) &&
                            <div className="choose-wallet-wrapper no-grid">
                                <div className="no-wallet-card">
                                    <h3 className="f-40 w-500 title">No Wallets Linked Yet</h3>
                                    <p className="f-20 w-500">You haven’t linked any wallet to this account yet, click on add wallet to link account</p>
                                    <ul className="btn-list">
                                        <li><a href="#" className="btn-style icon m-w-130" onClick={onAddWhitelistWalletShow}><img src={plusIcon} alt="icon" />Add Wallet</a></li>
                                    </ul>
                                </div>
                            </div>
                        }
                        {(listWallet.length !== 0) &&
                            <div className="wallet-table-wrapper">
                                <div className="asset-list-wrapper">
                                    <div className="asset-list desktop">
                                        <div className="table-header grid-4">
                                            <div className="asset-item">
                                                <p>Wallet</p>
                                            </div>
                                            <div className="asset-item">
                                                {/* <p>Balance</p> */}
                                            </div>
                                            <div className="asset-item">
                                                {/* <p>Balance in USD <img src={arrowDownIcon} alt="icon" /></p> */}
                                            </div>
                                            <div className="asset-item d-flex justify-content-center">
                                                <ul className="btn-list mr-2">
                                                    <li><a className="btn-style icon m-w-130 " onClick={onAddWhitelistWalletShow}><img src={plusIcon} alt="icon" />Add Wallet</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {listWallet && listWallet.map((res, index) => (
                                            <div className="asset-card grid-4">
                                                <div className="asset-item">
                                                    <div className="name-wrapper">
                                                        <div className="wallet-icon">
                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                            <img
                                                                src={userWiseCurrencyResponse.filter(result => result.currencycode == res.currencycode)?.[0]?.currencyimage}
                                                                className="tag-icon"
                                                                alt="img"
                                                            />
                                                        </div>
                                                        <div className="content">
                                                            <p className="title p">{res.type == 'F' ? res.bankname : res.walletname}</p>
                                                            <p>{res.currencycode}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="asset-item">
                                                    {/* <p className="p w-600">{res.amount * 0.0000097} BTC</p> */}
                                                </div>
                                                <div className="asset-item">
                                                    {/* <p className="p w-600">${res.amount} USD</p> */}
                                                </div>
                                                <div className="asset-item">
                                                    <ul className="btn-list">
                                                        <li><a onClick={() => hendelremovewallate(res._id)} className="btn-style h-36 transparent">Remove Wallet</a></li>
                                                    </ul>
                                                </div>
                                            </div>))}



                                        <div className="show-more">
                                            <a onClick={() => { handeladdwallet(true) }} className="btn-style transparent">Show More</a>
                                        </div>
                                    </div>
                                    <div className="asset-list-mobile">
                                        <div className="asset-list-card">
                                            <ul className="asset-detail">
                                                <li>
                                                    <div className="name-wrapper">
                                                        <div className="wallet-icon">
                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                            <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                        </div>
                                                        <div className="content">
                                                            <p className="title">John’s Test Wallet</p>
                                                            <p>BTC</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <p className="f-10">Portfolio %</p>
                                                    <p className="p w-600">12%</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Price</p>
                                                    <p className="p w-600">0.00323 USD</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Balance</p>
                                                    <p className="p w-600">0 BTC</p>
                                                </li>
                                            </ul>
                                            <ul className="asset-btn">
                                                <li><a href="#" className="btn-style h-36 transparent">Remove Wallet</a></li>
                                            </ul>
                                        </div>
                                        <div className="asset-list-card">
                                            <ul className="asset-detail">
                                                <li>
                                                    <div className="name-wrapper">
                                                        <div className="wallet-icon">
                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                            <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                        </div>
                                                        <div className="content">
                                                            <p className="title">John’s Test Wallet</p>
                                                            <p>BTC</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <p className="f-10">Portfolio %</p>
                                                    <p className="p w-600">12%</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Price</p>
                                                    <p className="p w-600">0.00323 USD</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Balance</p>
                                                    <p className="p w-600">0 BTC</p>
                                                </li>
                                            </ul>
                                            <ul className="asset-btn">
                                                <li><a href="#" className="btn-style h-36 transparent">Remove Wallet</a></li>
                                            </ul>
                                        </div>

                                        <div className="asset-list-card">
                                            <ul className="asset-detail">
                                                <li>
                                                    <div className="name-wrapper">
                                                        <div className="wallet-icon">
                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                            <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                        </div>
                                                        <div className="content">
                                                            <p className="title">John’s Test Wallet</p>
                                                            <p>BTC</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <p className="f-10">Portfolio %</p>
                                                    <p className="p w-600">12%</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Price</p>
                                                    <p className="p w-600">0.00323 USD</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Balance</p>
                                                    <p className="p w-600">0 BTC</p>
                                                </li>
                                            </ul>
                                            <ul className="asset-btn">
                                                <li><a href="#" className="btn-style h-36 transparent">Remove Wallet</a></li>
                                            </ul>
                                        </div>
                                        <div className="asset-list-card">
                                            <ul className="asset-detail">
                                                <li>
                                                    <div className="name-wrapper">
                                                        <div className="wallet-icon">
                                                            <img src={walletDarkIcon} className="wallet-icon" alt="img" />
                                                            <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                        </div>
                                                        <div className="content">
                                                            <p className="title">John’s Test Wallet</p>
                                                            <p>BTC</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <p className="f-10">Portfolio %</p>
                                                    <p className="p w-600">12%</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Price</p>
                                                    <p className="p w-600">0.00323 USD</p>
                                                </li>
                                                <li>
                                                    <p className="f-10">Balance</p>
                                                    <p className="p w-600">0 BTC</p>
                                                </li>
                                            </ul>
                                            <ul className="asset-btn">
                                                <li><a href="#" className="btn-style h-36 transparent">Remove Wallet</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </section>

            <section className="sec-broadcast-transaction">
                <div className="container">
                    <h3 className="f-24 w-500">Broadcast Transaction</h3>
                    <div className="broadcast-wrapper">
                        <div className="broadcast-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Raw Transaction</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <textarea className="form-control" placeholder="Enter transaction here"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="btn-wrapper">
                                        <a href="#" className="btn-style transparent icon"><img src={qrICon} alt="icon" />Scan QR</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="broadcast-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style transparent">Reset</a></li>
                                <li className="d-md-inline-block d-none"><a href="#" className="btn-style" onClick={onPublishWalletShow}>Publish</a></li>
                                <li className="d-inline-block d-md-none"><a href="#" className="btn-style" onClick={onPublishWalletMobileShow}>Publish</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div className="container">
                    <div className="link-wrapper">
                        <ul className="link-list">
                            <li><a href="#">Broadcast Transaction</a></li>
                            <li><a href="#">Buy Device</a></li>
                            <li><a href="#">Contact Us</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Disclaimer</a></li>
                        </ul>
                        <ul className="social-list">
                            <li><a href="#"><img src={linkedinICon} alt="icon" /></a></li>
                            <li><a href="#"><img src={twitterICon} alt="icon" /></a></li>
                            <li><a href="#"><img src={fbICon} alt="icon" /></a></li>
                        </ul>
                    </div>
                </div>
            </footer>

            {/* Publish Wallet Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-modal" show={publishWalletShow} onHide={onPublishWalletClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-9 align-self-center">
                                    <h3 className="h3">Add Self-Custody Wallet</h3>
                                </div>
                                <div className="col-3 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onPublishWalletClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Select Blockchain Network</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Name your wallet</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter wallet name here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="scan-qr-wrapper">
                                        <p className="p w-500 or">OR</p>
                                        <a href="#" className="btn-style transparent icon"><img src={qrICon} alt="icon" />Scan QR to Add Address</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style transparent" onClick={onPublishWalletClose}>Cancel</a></li>
                                <li><a href="#" className="btn-style" onClick={onPublishWalletClose}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Publish Wallet Modal End */}
            <Whitelist
                UserCurrencyResponse={userWiseCurrencyResponse.map(res => {
                    if (res.type == 'F') {
                        res.currencyimage = res.currencycode.toLowerCase() == 'usd' ? usdLogo : euroLogo;
                    }
                    return {
                        label: res.currencycode,
                        shortName: res.currencycode,
                        icon: res.currencyimage,
                        type: res.type
                    };
                })}
                addAddwalletWalletShow={addWallet}
                onAddAddwalletWalletClose={onAddWhitelistWalletClose}
                email={(JSON.parse(sessionvalue))?.email || ''}
            />
            {/* Assets Withdraw Modal Start */}
            <Offcanvas show={publishWalletMobileShow} className="deposit-select-wallet-modal h-595" onHide={onPublishWalletMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-9 align-self-center">
                                    <h3 className="h3">Add Self-Custody Wallet</h3>
                                </div>
                                <div className="col-3 align-self-center">
                                    <div className="reset-wrapper">
                                        {/*<a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon"/></a>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Select Blockchain Network</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Name your wallet</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter wallet name here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="scan-qr-wrapper">
                                        <p className="p w-500 or">OR</p>
                                        <a href="#" className="btn-style transparent icon"><img src={qrICon} alt="icon" />Scan QR to Add Address</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onPublishWalletMobileClose}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Assets Withdraw Modal End */}
        </div>
    )
}

export default ChooseWallet
